<template>
    <div class="all-page">
        <section class="tool-bar">
            <el-button type="primary" class="add-btn" @click="openAddDialog">
                {{ $t("AiPortalSetting.add") }}
            </el-button>
        </section>
        
        <!-- 模块添加/编辑对话框 -->
        <el-dialog v-model="moduleDialogVisible" :title="dialogTitle" width="800" style="z-index: 99999;">
            <el-form ref="moduleFormRef" :model="moduleForm" :rules="formRules" label-width="120px" style="padding: 20px;">
                <!-- LOGO上传 -->
                <el-form-item :label="$t('AiPortalSetting.logo')">
                    <el-upload
                        class="logo-uploader"
                        :show-file-list="false"
                        :on-success="handleLogoSuccess"
                        :before-upload="beforeLogoUpload"
                        :action="uploadFileUrl"
                        :data="LogoForm"
                        :headers="{ Authorization: `Bearer ` + getAccessToken() }">
                        <img v-if="moduleForm.logo" :src="moduleForm.logo + '?' + getSasTokenFromCache()" class="logo-preview" />
                        <el-icon v-else class="logo-uploader-icon"><Plus /></el-icon>
                    </el-upload>
                </el-form-item>

                <!-- 标题 - 三种语言 -->
                <el-form-item :label="$t('AiPortalSetting.title')" required>
                    <el-tabs v-model="activeTab" type="border-card" style="width: 100%;">
                        <el-tab-pane label="中文" name="zh">
                            <el-form-item prop="title.zh" style="margin-bottom: 0;">
                                <el-input v-model="moduleForm.title.zh" :placeholder="$t('inputMsg')" />
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="English" name="en">
                            <el-form-item prop="title.en" style="margin-bottom: 0;">
                                <el-input v-model="moduleForm.title.en" :placeholder="$t('inputMsg')" />
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="日本語" name="jp">
                            <el-form-item prop="title.jp" style="margin-bottom: 0;">
                                <el-input v-model="moduleForm.title.jp" :placeholder="$t('inputMsg')" />
                            </el-form-item>
                        </el-tab-pane>
                    </el-tabs>
                </el-form-item>

                <!-- 描述 - 三种语言 -->
                <el-form-item :label="$t('AiPortalSetting.description')" required>
                    <el-tabs v-model="activeDescTab" type="border-card" style="width: 100%;">
                        <el-tab-pane label="中文" name="zh">
                            <el-form-item prop="description.zh" style="margin-bottom: 0;">
                                <el-input v-model="moduleForm.description.zh" type="textarea" rows="3" :placeholder="$t('inputMsg')" />
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="English" name="en">
                            <el-form-item prop="description.en" style="margin-bottom: 0;">
                                <el-input v-model="moduleForm.description.en" type="textarea" rows="3" :placeholder="$t('inputMsg')" />
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="日本語" name="jp">
                            <el-form-item prop="description.jp" style="margin-bottom: 0;">
                                <el-input v-model="moduleForm.description.jp" type="textarea" rows="3" :placeholder="$t('inputMsg')" />
                            </el-form-item>
                        </el-tab-pane>
                    </el-tabs>
                </el-form-item>

                <!-- 按钮名称 - 三种语言 -->
                <el-form-item :label="$t('AiPortalSetting.buttonName')" required>
                    <el-tabs v-model="activeButtonTab" type="border-card" style="width: 100%;">
                        <el-tab-pane label="中文" name="zh">
                            <el-form-item prop="buttonName.zh" style="margin-bottom: 0;">
                                <el-input v-model="moduleForm.buttonName.zh" :placeholder="$t('inputMsg')" />
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="English" name="en">
                            <el-form-item prop="buttonName.en" style="margin-bottom: 0;">
                                <el-input v-model="moduleForm.buttonName.en" :placeholder="$t('inputMsg')" />
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="日本語" name="jp">
                            <el-form-item prop="buttonName.jp" style="margin-bottom: 0;">
                                <el-input v-model="moduleForm.buttonName.jp" :placeholder="$t('inputMsg')" />
                            </el-form-item>
                        </el-tab-pane>
                    </el-tabs>
                </el-form-item>

                <!-- 按钮URL -->
                <el-form-item :label="$t('AiPortalSetting.buttonUrl')">
                    <el-input v-model="moduleForm.buttonUrl" :placeholder="$t('AiPortalSetting.buttonUrlPlaceholder')" />
                </el-form-item>

                <!-- 背景图片上传 -->
                <el-form-item :label="$t('AiPortalSetting.backgroundImage')">
                    <el-upload
                        class="bg-uploader"
                        :show-file-list="false"
                        :on-success="handleBgSuccess"
                        :before-upload="beforeBgUpload"
                        :action="uploadFileUrl"
                        :data="BgForm"
                        :headers="{ Authorization: `Bearer ` + getAccessToken() }">
                        <img v-if="moduleForm.backgroundImage" :src="moduleForm.backgroundImage + '?' + getSasTokenFromCache()" class="bg-preview" />
                        <el-icon v-else class="bg-uploader-icon"><Plus /></el-icon>
                    </el-upload>
                </el-form-item>

                <!-- 状态 -->
                <el-form-item :label="$t('AiPortalSetting.status')">
                    <el-select v-model="moduleForm.status" :placeholder="$t('selectMsg')">
                        <el-option :label="$t('AiPortalSetting.online')" :value="1" />
                        <el-option :label="$t('AiPortalSetting.preparing')" :value="2" />
                        <el-option :label="$t('AiPortalSetting.comingSoon')" :value="3" />
                    </el-select>
                </el-form-item>

                <!-- 类型 -->
                <el-form-item :label="$t('AiPortalSetting.type')">
                    <el-select v-model="moduleForm.type" :placeholder="$t('selectMsg')">
                        <el-option :label="$t('AiPortalSetting.assistant')" :value="1" />
                        <el-option :label="$t('AiPortalSetting.tool')" :value="2" />
                    </el-select>
                </el-form-item>

            </el-form>
            
            <template #footer>
                <div style="display: flex; justify-content: center; gap: 10px;">
                    <el-button @click="moduleDialogVisible = false">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="handleModuleSubmit" class="add-btn">{{ $t('submit') }}</el-button>
            </div>
            </template>
        </el-dialog>

        <!-- 表格容器 -->
        <section class="table-container">
            <el-table :data="tableData" style="width: 100%; --el-color-primary: #f36633">
                <el-table-column :label="$t('AiPortalSetting.logo')" width="80">
                    <template #default="scope">
                        <img v-if="scope.row.logo" :src="scope.row.logo + '?' + getSasTokenFromCache()" class="table-logo" />
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('AiPortalSetting.title')" min-width="200">
                    <template #default="scope">
                        {{ getCurrentTitle(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('AiPortalSetting.description')" min-width="300">
                    <template #default="scope">
                        <div class="description-cell">{{ getCurrentDescription(scope.row) }}</div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('AiPortalSetting.buttonName')" width="150">
                    <template #default="scope">
                        {{ getCurrentButtonName(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('AiPortalSetting.buttonUrl')" width="200">
                    <template #default="scope">
                        <el-link :href="scope.row.buttonUrl" target="_blank" type="primary" style="word-break: break-all;">
                            {{ scope.row.buttonUrl }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('AiPortalSetting.status')" width="100">
                    <template #default="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'info' : 'warning'">
                            {{ scope.row.status === 1 ? $t('AiPortalSetting.online') : scope.row.status === 2 ? $t('AiPortalSetting.preparing') : $t('AiPortalSetting.comingSoon') }}
                        </el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column :label="$t('AiPortalSetting.type')" width="100">
                    <template #default="scope">
                        <el-tag :type="scope.row.type === 1 ? 'primary' : 'warning'">
                            {{ scope.row.type === 1 ? $t('AiPortalSetting.assistant') : $t('AiPortalSetting.tool') }}
                        </el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column :label="$t('createTime')" width="150">
                    <template #default="scope">
                        <span style="color: #868693">{{ formatTimestamp(scope.row.create_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('action')" width="120">
                    <template #default="scope">
                        <el-button link type="primary" @click="handleEdit(scope.row)" style="margin-right: 8px;">
                            <el-icon><Edit /></el-icon>
                        </el-button>
                        <el-button link type="danger" @click="() => handleRowDelete(scope.row.id)">
                            <el-icon><Delete /></el-icon>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </section>

        <footer class="footer">
            <el-pagination small background layout="prev, pager, next, total" 
                :current-page="currentPage"
                :page-size="pageNum"
                :total="totalRecords"
                @current-change="handleCurrentPageChange" 
                style="--el-color-primary: #f36633" />
            <!-- Footer 选择个数部分 -->
            <el-select class="select-number" v-model="pageNum" @change="handlePageNumChange">
                <el-option v-for="item in [10, 20, 30, 40, 50]" :key="item" :label="item + '/page'"
                    :value="item"></el-option>
            </el-select>
        </footer>
    </div>
</template>

<style scoped>
/* .all-page {
    position: relative;
    z-index: 2;
} */
.tool-bar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    /* margin-top: -60px;
    padding-bottom: 60px; */
}

.title-text {
    color: #000;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
}

.select-number {
    width: 10rem;
    --el-color-primary: #f36633;
}

.table-container {
    padding-bottom: 10rem;
}

.footer {
    position: fixed;
    left: 2rem;
    right: 2rem;
    align-items: center;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    z-index: 999;
    background-color: white;
    padding-top: 1rem;
    padding-bottom: 1rem;
    box-sizing: border-box;
}

.custom-avatar {
    margin-right: 0.5rem;
    border: 2px solid rgba(174, 174, 183, 0.2);
    flex-shrink: 0;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #f36633;
    border-color: #f36633;
}

.add-btn {
    color: #fff;
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    padding: 0.5rem 1rem;
    border-radius: 10px;
    --el-button-bg-color: #f36633 !important;
    --el-button-border-color: #f36633 !important;
    --el-button-hover-bg-color: #376f7b !important;
    --el-button-hover-text-color: white !important;
    --el-button-hover-border-color: #376f7b !important;
    --el-button-active-bg-color: #376f7b !important;
    --el-button-active-border-color: #376f7b !important;
}

/* 上传组件样式 */
.logo-uploader, .bg-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: 0.2s;
    background: #f6f6f6;
}

.logo-uploader:hover, .bg-uploader:hover {
    border-color: #f36633;
}

.logo-uploader-icon, .bg-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    text-align: center;
    line-height: 80px;
}

.logo-preview {
    width: 80px;
    height: 80px;
    display: block;
    object-fit: cover;
}

.bg-preview {
    width: 200px;
    height: 120px;
    display: block;
    object-fit: cover;
}

.table-logo {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
}

.description-cell {
    max-width: 300px;
    word-break: break-word;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>

<script lang="ts">
import { onMounted, inject, ref, computed } from 'vue';
import { AxiosInstance } from "axios";
import { formatTimestamp } from "@/utils/formatTimestamp";
import { ElMessage, ElMessageBox } from 'element-plus';
import { useI18n } from "vue-i18n";
import { Delete, Edit, Plus } from "@element-plus/icons-vue";
import { getUserInfo, getAccessToken } from "@/state/UserInfo";
import { getSasTokenFromCache } from "@/state/getSasToken";

export default {
    name: 'AiPortalManageView',
    components: {
    },
    setup() {
        const { t, locale } = useI18n();

        const totalRecords = ref<number>(0);
        
        interface ModuleData {
            id: number;
            logo: string;
            title: {
                zh: string;
                en: string;
                jp: string;
            };
            description: {
                zh: string;
                en: string;
                jp: string;
            };
            buttonName: {
                zh: string;
                en: string;
                jp: string;
            };
            buttonUrl: string;
            backgroundImage: string;
            status: 1;
            type: 1;
            CreatedOn: string;
            User: {
                UserName: string;
                Avatar: string;
            };
        }

        const tableData = ref<ModuleData[]>([]);
        const pageNum = ref(10);
        const currentPage = ref(1);
        const axiosInstance = inject("axiosInstance") as AxiosInstance;
        const moduleDialogVisible = ref(false);
        const isEditMode = ref(false);
        const editingId = ref<number | null>(null);
        const moduleFormRef = ref<any>(null);

        // 表单数据
        const moduleForm = ref({
            logo: '',
            title: {
                zh: '',
                en: '',
                jp: ''
            },
            description: {
                zh: '',
                en: '',
                jp: ''
            },
            buttonName: {
                zh: '',
                en: '',
                jp: ''
            },
            buttonUrl: '',
            backgroundImage: '',
            status: 1,
            type: 1
        });

        // 表单验证规则
        const formRules = ref({
            'title.zh': [
                { required: true, message: '请输入中文标题', trigger: 'blur' },
                { min: 1, max: 100, message: '标题长度应在 1-100 字符之间', trigger: 'blur' }
            ],
            'title.en': [
                { required: true, message: 'Please enter English title', trigger: 'blur' },
                { min: 1, max: 100, message: 'Title length should be 1-100 characters', trigger: 'blur' }
            ],
            'title.jp': [
                { required: true, message: '日本語のタイトルを入力してください', trigger: 'blur' },
                { min: 1, max: 100, message: 'タイトルの長さは1-100文字である必要があります', trigger: 'blur' }
            ],
            'description.zh': [
                { required: true, message: '请输入中文描述', trigger: 'blur' },
                { min: 1, max: 500, message: '描述长度应在 1-500 字符之间', trigger: 'blur' }
            ],
            'description.en': [
                { required: true, message: 'Please enter English description', trigger: 'blur' },
                { min: 1, max: 500, message: 'Description length should be 1-500 characters', trigger: 'blur' }
            ],
            'description.jp': [
                { required: true, message: '日本語の説明を入力してください', trigger: 'blur' },
                { min: 1, max: 500, message: '説明の長さは1-500文字である必要があります', trigger: 'blur' }
            ],
            'buttonName.zh': [
                { required: true, message: '请输入中文按钮名称', trigger: 'blur' },
                { min: 1, max: 50, message: '按钮名称长度应在 1-50 字符之间', trigger: 'blur' }
            ],
            'buttonName.en': [
                { required: true, message: 'Please enter English button name', trigger: 'blur' },
                { min: 1, max: 50, message: 'Button name length should be 1-50 characters', trigger: 'blur' }
            ],
            'buttonName.jp': [
                { required: true, message: '日本語のボタン名を入力してください', trigger: 'blur' },
                { min: 1, max: 50, message: 'ボタン名の長さは1-50文字である必要があります', trigger: 'blur' }
            ]
        });

        // Tab控制
        const activeTab = ref('zh');
        const activeDescTab = ref('zh');
        const activeButtonTab = ref('zh');

        // 上传配置
        const uploadFileUrl = process.env.VUE_APP_BASE_URL + "api/FileHandler/UploadFile";
        const generateGuid = () => {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function (c) {
                    var r = (Math.random() * 16) | 0,
                        v = c === "x" ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                }
            );
        };
        const LogoGuid = generateGuid();
        const LogoForm = ref({
            IdeaId: 0,
            UserId: getUserInfo()!.graphUserInfo!.UserId,
            AttGuid: LogoGuid,
            SceneType: 2,
        });
        const BgGuid = generateGuid();
        const BgForm = ref({
            IdeaId: 0,
            UserId: getUserInfo()!.graphUserInfo!.UserId,
            AttGuid: BgGuid,
            SceneType: 2,
        });

        const dialogTitle = computed(() => {
            return isEditMode.value ? t('AiPortalSetting.editModule') : t('AiPortalSetting.addModule');
        });

        onMounted(() => {
            GetModuleList()
        })

        // 获取当前语言对应的文本
        const getCurrentTitle = (row: ModuleData) => {
            const lang = locale.value as keyof typeof row.title;
            return row.title[lang] || row.title.zh || '-';
        };

        const getCurrentDescription = (row: ModuleData) => {
            const lang = locale.value as keyof typeof row.description;
            return row.description[lang] || row.description.zh || '-';
        };

        const getCurrentButtonName = (row: ModuleData) => {
            const lang = locale.value as keyof typeof row.buttonName;
            return row.buttonName[lang] || row.buttonName.zh || '-';
        };

        // 打开添加对话框
        const openAddDialog = () => {
            isEditMode.value = false;
            editingId.value = null;
            resetForm();
            moduleDialogVisible.value = true;
        };

        // 重置表单
        const resetForm = () => {
            moduleForm.value = {
                logo: '',
                title: { zh: '', en: '', jp: '' },
                description: { zh: '', en: '', jp: '' },
                buttonName: { zh: '', en: '', jp: '' },
                buttonUrl: '',
                backgroundImage: '',
                status: 1,
                type: 1
            };
            // 清除表单验证状态
            if (moduleFormRef.value) {
                moduleFormRef.value.resetFields();
            }
        };

        // 编辑
        const handleEdit = (row: ModuleData) => {
            isEditMode.value = true;
            editingId.value = row.id;
            moduleForm.value = {
                logo: row.logo,
                title: { ...row.title },
                description: { ...row.description },
                buttonName: { ...row.buttonName },
                buttonUrl: row.buttonUrl,
                backgroundImage: row.backgroundImage,
                status: row.status,
                type: row.type
            };
            moduleDialogVisible.value = true;
        };

        // 数据转换函数：将multilingual_data数组转换为前端格式
        const transformMultilingualData = (data: any[]) => {
            return data.map(item => {
                const transformedItem = { ...item };
                
                // 初始化多语言对象
                transformedItem.title = { zh: '', en: '', jp: '' };
                transformedItem.description = { zh: '', en: '', jp: '' };
                transformedItem.buttonName = { zh: '', en: '', jp: '' };
                
                // 遍历多语言数据，填充对应语言的内容
                if (item.multilingual_data && Array.isArray(item.multilingual_data)) {
                    item.multilingual_data.forEach((langData: any) => {
                        const langType = langData.type;
                        if (transformedItem.title.hasOwnProperty(langType)) {
                            transformedItem.title[langType] = langData.title || '';
                            transformedItem.description[langType] = langData.description || '';
                            transformedItem.buttonName[langType] = langData.bottom_name || '';
                        }
                    });
                }
                
                transformedItem.logo = item.logo;
                transformedItem.backgroundImage = item.background_image;
                transformedItem.buttonUrl = item.button_url;
                transformedItem.status = item.status;
                transformedItem.type = item.type;
                transformedItem.create_time = item.create_time;
                return transformedItem;
            });
        };

        const GetModuleList = async () => {
            axiosInstance.post("api/AiPortalPageBanner/GetAiPortalPageBannerList", 
              {
                "logo": "",
                "title": "",
                "status": null,
                "type": null,
                "pageSize": pageNum.value,
                "pageIndex": currentPage.value
              }
            ).then((res) => {
              let _data = res.data.Data.data;
              
              // 对获取的数据进行转换处理
              const transformedData = transformMultilingualData(_data);
              console.log('-----',transformedData);
              
              tableData.value = transformedData;
              totalRecords.value = res.data.Data.rowCount;
            });
        }

        const handleCurrentPageChange = (val: number) => {
            currentPage.value = val;
            GetModuleList();
        };

        const handlePageNumChange = () => {
            // 当页面大小改变时，重置到第一页
            currentPage.value = 1;
            GetModuleList();
        };

        const handleRowDelete = (moduleId: number) => {
            ElMessageBox.confirm(
                t('warningmsg'),
                t('Warning'),
                {
                    confirmButtonText: t('confirm'),
                    cancelButtonText: t('cancel'),
                    type: 'warning',
                }
            ).then(() => {
                DeleteModule(moduleId);
            }).catch(() => {
                GetModuleList();
            });
        }

        const DeleteModule = (moduleId: number) => {
            axiosInstance.post(`api/AiPortalPageBanner/DeleteAiPortalPageBanner?id=${moduleId}`).then((res) => {
                ElMessage.success(t('deletesuccess'));
                GetModuleList();
            });
        }

        const handleModuleSubmit = async () => {
            // 验证表单
            if (!moduleFormRef.value) return;
            
            try {
                await moduleFormRef.value.validate();
                
                // 表单验证通过后执行提交逻辑
                const apiUrl = isEditMode.value ? 'api/AiPortalPageBanner/UpdateAiPortalPageBanner' : 'api/AiPortalPageBanner/AddAiPortalPageBanner';
                const payload = {
                    button_url: moduleForm.value.buttonUrl,
                    background_image: moduleForm.value.backgroundImage,
                    logo: moduleForm.value.logo,
                    status: moduleForm.value.status,
                    type: moduleForm.value.type,
                    multilingual_data: [
                      {
                        type: "en",
                        title: moduleForm.value.title.en,
                        description: moduleForm.value.description.en,
                        bottom_name: moduleForm.value.buttonName.en
                      },
                      {
                        type: "jp",
                        title: moduleForm.value.title.jp,
                        description: moduleForm.value.description.jp,
                        bottom_name: moduleForm.value.buttonName.jp
                      },
                      {
                        type: "zh",
                        title: moduleForm.value.title.zh,
                        description: moduleForm.value.description.zh,
                        bottom_name: moduleForm.value.buttonName.zh
                      }
                    ],
                    ...(isEditMode.value ? { id: editingId.value } : {})
                };
                axiosInstance.post(apiUrl, payload).then((res) => {
                  console.log(res)
                    if (res.data.Successed) {
                        ElMessage.success(isEditMode.value ? '修改成功！' : '添加成功！');
                        GetModuleList();
                        moduleDialogVisible.value = false;
                        // ElMessage.success(t('submitSuccess'));
                    } else {
                        ElMessage.error(t('submitFailed'));
                    }
                });
            } catch (error) {
                console.log('表单验证失败:', error);
                ElMessage.error('请检查必填项是否完整！');
            }
        }

        // 文件上传处理
        interface UploadFileResponse {
            AttId: number;
            AttName: string;
            AttPath: string;
            BlobFileName: string;
            ContainerName: string;
            CreatedBy: number;
            IdeaID: number;
            Type: number;
        }
        interface ResponseData {
            Data: UploadFileResponse[];
        }

        const handleLogoSuccess = (response: ResponseData) => {
            console.log("Logo upload success:", response);
            moduleForm.value.logo = response.Data[0].AttPath;
        };

        const handleBgSuccess = (response: ResponseData) => {
            console.log("Background upload success:", response);
            moduleForm.value.backgroundImage = response.Data[0].AttPath;
        };

        const beforeLogoUpload = (file: File) => {
            const isAllowFileType =
                file.type === "image/jpeg" ||
                file.type === "image/png" ||
                file.type === "image/gif";
            const isLt500M = file.size / 1024 / 1024 < 500;

            if (!isAllowFileType) {
                ElMessage.error("只能上传 JPG、JPEG、PNG 或 GIF 格式的图片");
            }
            if (!isLt500M) {
                ElMessage.error("文件大小不能超过 500MB");
            }

            return isAllowFileType && isLt500M;
        };

        const beforeBgUpload = (file: File) => {
            return beforeLogoUpload(file);
        };

        return {
            totalRecords,
            tableData,
            pageNum,
            currentPage,
            GetModuleList,
            moduleDialogVisible,
            moduleForm,
            moduleFormRef,
            formRules,
            activeTab,
            activeDescTab,
            activeButtonTab,
            dialogTitle,
            isEditMode,
            handleCurrentPageChange,
            handlePageNumChange,
            formatTimestamp,
            handleModuleSubmit,
            handleRowDelete,
            openAddDialog,
            handleEdit,
            getCurrentTitle,
            getCurrentDescription,
            getCurrentButtonName,
            handleLogoSuccess,
            handleBgSuccess,
            beforeLogoUpload,
            beforeBgUpload,
            uploadFileUrl,
            LogoForm,
            BgForm,
            getUserInfo,
            getAccessToken,
            getSasTokenFromCache
        }
    }
}
</script>